import { Box } from "@chakra-ui/react";
import React from "react";

const FlexRow = ({children, ...extraParams}) => <Box {...extraParams } display="flex" alignItems="center" flexDirection="row">{ children }</Box>;

export default FlexRow;
